import { useQuery } from "@tanstack/react-query";
import { Clock3, Globe2, Mail, SlidersHorizontal } from "lucide-react";
import { ErrorState, LoadingState } from "../../components/States";
import { settingsApi } from "../../services/settingsApi";

export function SettingsPage() {
  const settingsQuery = useQuery({ queryKey: ["settings"], queryFn: settingsApi.get });
  if (settingsQuery.isLoading) return <LoadingState label="Ladataan asetuksia…" />;
  if (settingsQuery.isError) return <ErrorState />;
  const settings = settingsQuery.data!;

  return <>
    <section className="page-heading">
      <div><span className="kicker">SAATAVUUSKYSELYT</span><h1>Oletusasetukset</h1><p>Elisa-saatavuuskyselyissä käytettävät yhteiset perustiedot.</p></div>
    </section>
    <div className="settings-grid settings-grid--module">
      <section className="card settings-card settings-card--wide">
        <div className="settings-card__title"><span><SlidersHorizontal /></span><div><h2>Oletusasetukset</h2><p>Kyselylomakkeella ja automaattisissa tarkistuksissa käytettävät arvot</p></div></div>
        <div className="setting-row"><Mail /><div><span>Oletussähköposti</span><strong>{settings.defaultEmail}</strong></div></div>
        <div className="setting-row"><Globe2 /><div><span>Operaattori</span><strong>{settings.operator}</strong></div></div>
        <div className="setting-row"><Clock3 /><div><span>Tarkistusajojen ajat</span><strong>{settings.checkSchedule.join(" · ")}</strong><small>Suomen aikaa 06/12/15 talvella ja 07/13/16 kesällä.</small></div></div>
      </section>
    </div>
  </>;
}
